import React from 'react';
import { ChevronLeftIcon } from '@heroicons/react/24/outline';

export type BreadcrumbProps = {
  Separator?: React.ReactNode;
  className?: string;
  listClassName?: string;
};

const Breadcrumb = ({
  children,
  Separator = '/',
  className = '',
  listClassName = '',
}: React.PropsWithChildren<BreadcrumbProps>) => {
  return (
    <nav className={`scrollbar-hide ${className}`} aria-label="Breadcrumb">
      <div className={`grid grid-cols-[24px_auto] items-center gap-x-4`}>
        <div className="flex items-center">
          <ChevronLeftIcon className="text-icon-primary" width={24} height={24} />
        </div>

        <ol role="list" className={`flex flex-wrap items-center gap-x-4 gap-y-8 whitespace-normal ${listClassName}`}>
          {React.Children.map(children, (Child, index) => (
            <>
              <li>
                <div>{Child}</div>
              </li>
              {Separator && index < React.Children.count(children) - 1 && <span>{Separator}</span>}
            </>
          ))}
        </ol>
      </div>
    </nav>
  );
};

export default Breadcrumb;
